import { createFileRoute } from '@tanstack/react-router';

import { TodayPage } from '@/features/site/today-page';

export const Route = createFileRoute('/_app/projects/$projectId/site/today')({
  component: TodayRoute,
});

function TodayRoute() {
  const { projectId } = Route.useParams();
  return <TodayPage projectId={projectId} />;
}
